import { render, staticRenderFns } from "./highlighted-textarea.vue?vue&type=template&id=b0951ca6&scoped=true&"
import script from "./highlighted-textarea.vue?vue&type=script&lang=js&"
export * from "./highlighted-textarea.vue?vue&type=script&lang=js&"
import style0 from "./highlighted-textarea.vue?vue&type=style&index=0&id=b0951ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0951ca6",
  null
  
)

export default component.exports